<template>
  <div class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-md md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl cobalt-text-color">
              Verify Account
            </div>
          </div>
          <form class="mt-4 space-y-6" @submit.prevent="verify" novalidate>
            <div class="rounded-sm">
                <VOtpInput
                :class="{ 'border-red-400': v$.form.otp_code.$error }"
        input-classes="otp-input"
        :conditionalClass="['one', 'two', 'three', 'four','five','six']"
        separator="-"
        inputType="letter-numeric"
        :num-inputs="6"
        v-model:value="form.otp_code"
        :should-auto-focus="true"
        :should-focus-order="true"
        :placeholder="['*', '*', '*', '*','*','*']"
      />
      <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.otp_code.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'minLength'">
                    Enter minimum six letters
                  </div>
                </div>
                <p class="text-start">
                  Didn’t Receive Code?
                  <a @click="handleClickResend()" href="javascript:void(0)"
                    >Resend</a
                  >
                </p>
              </div>
            <div>
              <button
                type="submit"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                aria-required="true"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    class="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                Verify Account
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VOtpInput from "vue3-otp-input";
import useVuelidate from "@vuelidate/core";
import { mapState } from "vuex";
import { required,minLength } from "@vuelidate/validators";
// import { ref } from "vue";
export default {
  name: "Register",
  setup() {
    return { v$: useVuelidate() };
  },
  components:{VOtpInput},
  computed: mapState(["agent_data"]),
  data: function() {
    return {
      form: {
        otp_code:""
      },
      otp_data:{
  'OTP_conditionalClass': ["one", "two", "three", "four", "five", "six"],
  'OTP_placeHolder': ["*", "*", "*", "*", "*", "*"],
  'OTP_separator': "<span style='color:#F8FAFC'>aa<span>"
}
    };
  },
  validations() {
    return {
      form: {
        otp_code: {
          required,
          minLength: minLength(6),
        }
      },
    };
  },
  mounted() {
    let agent_data=localStorage.getItem('registered_email');
    if(this.agent_data!=null && this.agent_data!=""){
        if(agent_data==null || agent_data=="" || agent_data==undefined){
            this.$toast.error("Please SignUp first!");
            this.$router.push("/register");
        }
    }else{
        this.$toast.error("Please SignUp first!");
        this.$router.push("/login");
    }
  },
  created() {
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value.length != 0) {
          this.$toast.error("Something went wrong, please try again!");
        }
      }
    );
  },
  methods: { 
    handleClickResend: function() {
      this.form.username = this.agent_data.data.email;
      this.$store.dispatch("resendOTP", this.form).then((result) => {
        console.log(result)
        this.$toast.success("OTP sent again, please check email now");
        })
        .catch((error) => {
          this.$toast.error(error);
         console.log(error)
        });
    },
    verify: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (
        this.v$.form.$pending ||
        this.v$.form.$error)
        return;
    this.form.username = this.agent_data.data.email;
      this.$store.dispatch("verifyOTP", this.form).then((result) => {
        console.log(result)
        this.$toast.success("Verified successfully,you can login now.");
        localStorage.removeItem('registered_email')
        this.$router.push("/login");
        })
        .catch((error) => {
          this.$toast.error(error);
         console.log(error)
        });
    }
  },
};
</script>

<style>
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>